import { IOption } from 'common/interfaces/IOption'

export const getDefaultComparisonEncounterUid = (
  primaryEncounterUid: string | null,
  encounterOptions: IOption[],
): string | null => {
  if (!encounterOptions?.length) {
    return null
  }

  const firstEncounter = encounterOptions[0]

  if (primaryEncounterUid === firstEncounter.code) {
    if (encounterOptions.length > 1) {
      return encounterOptions[1].code as string
    }
    return null
  }

  return firstEncounter.code as string
}

type ResolveComparisonEncounterUidParams = {
  primaryEncounterUid: string | null
  currentComparisonEncounterUid: string | null
  encounterOptions: IOption[]
}

export const resolveComparisonEncounterUid = ({
  primaryEncounterUid,
  currentComparisonEncounterUid,
  encounterOptions,
}: ResolveComparisonEncounterUidParams): string | null => {
  if (encounterOptions.length < 2) {
    return null
  }

  const isCurrentComparisonPresent = encounterOptions.some(
    (option) => option.code === currentComparisonEncounterUid,
  )

  if (
    currentComparisonEncounterUid &&
    currentComparisonEncounterUid !== primaryEncounterUid &&
    isCurrentComparisonPresent
  ) {
    return currentComparisonEncounterUid
  }

  return getDefaultComparisonEncounterUid(primaryEncounterUid, encounterOptions)
}

export const getAdjustedEncounterOptions = (
  options: IOption[],
  valueToDisable: string | null,
): IOption[] => {
  return options.map((option) => ({
    ...option,
    disabled: option.code === valueToDisable,
  }))
}
